module.exports = "/packs/payment-schedule-image-pc-a8d378d99006f2bbe443ddf85675226d.png";